import React from 'react';
import s from './style.module.sass';

export default function AddToBasket() {
    return (
        <button className={s.btn}>Add to basket</button>
    )
}
